import {
    AfterViewChecked, AfterViewInit,
    Component, ContentChild,
    ContentChildren, Directive,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges, OnDestroy,
    OnInit,
    Output,
    QueryList,
    SimpleChanges, ViewChild,
    ViewChildren
} from '@angular/core';
import {EntityCollectionDeleteService} from '../../service/entityCollectionDeleteService';
import {Subscription} from 'rxjs';
import {BaseView} from '../../view/base.view';
import {EntityWithCreatedAtMetadata} from '../../../common/entity/entityWithCreatedAtMetadata';
import {Moment} from 'moment-timezone';
import {EntityWithAuditMetadata} from '../../../common/entity/entityWithAuditMetadata';
import {PermissionsModel} from '../../../common/entity/permissions.model';
import {PermissionUtils} from '../../../common/permission/api/utils/permission.utils';
import {ConfirmationButtonOptionModel} from '../../../../components/common/button/confirmation-button/model/confirmationButtonOption.model';
import {AbstractDeleteOneService} from '../../service/v2/service/delete/abstractDeleteOne.service';
import {ButtonComponent} from '../button/button.component';

@Directive({
    selector: '[more-buttons]'
})
export class MoreButtonsDirective {}


@Component({
  selector: 'app-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.scss']
})
export class ItemComponent<T> extends BaseView implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @ViewChild('content', { static: true }) contentRef!: ElementRef<HTMLElement>;
  @ViewChildren(ButtonComponent, { read: ElementRef }) buttons: QueryList<ElementRef>;
  @ContentChildren(ButtonComponent, { read: ElementRef }) additionalButtons: QueryList<ElementRef>;
  @ContentChildren(MoreButtonsDirective) moreButtonsContents!: QueryList<MoreButtonsDirective>;

  @Input() entity: T;
  @Input() deleteService: EntityCollectionDeleteService<any> | AbstractDeleteOneService<any, any>;
  @Input() deleteWarningMessage: string;
  @Input() deleteConfirmationMessage = 'Suppression effectuée';
  @Input() deleteBuildPayload: (entity: any) => any;
  @Input() resolveUpdateUrl: (entity: T) => string;
  @Input() hideUpdateButton = false;
  @Input() href: string;
  @Input() urlAfterEdition;
  @Input() showMetadata = false;
  @Input() displayViewButton = false;

  @Input() deleteButtonInMore = false;
  @Input() editButtonInMore = false;
  @Input() viewButtonInMore = false;
  displayButtonsInMore = false;


  // Review these below
  @Input() button = false;
  @Input() lines = true;

  @Output() entityDeleted = new EventEmitter<string | number>();
  @Output() updateButtonClicked = new EventEmitter<T>();
  @Output() viewClicked = new EventEmitter<T>();

  subscriptions: Subscription[] = [];
  deleteLoading: boolean;
  confirmationButtonOption: ConfirmationButtonOptionModel = {
      confirmationText: 'Confirmez-vous la suppression?',
  };

  constructor() {
    super();
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['deleteWarningMessage']) {
            if (this.deleteWarningMessage) {
                this.confirmationButtonOption.confirmationText = this.deleteWarningMessage;
            }
        }
    }

    get displayDeleteButton(): boolean {
        const permissions: PermissionsModel = PermissionUtils.getPermission(this.entity);
        if (!this.deleteService) {
            return false;
        }
        return permissions?.deletable;
    }
  ngOnInit() {
      // // console.logByTypethis.entity);
    this.deleteLoading = false;
    if (this.deleteService) {
        if (this.deleteService instanceof AbstractDeleteOneService) {
            this.subscriptions.push(this.deleteService.error$.subscribe(value => {
                if (value) {
                    this.toastControl.presentError(value);
                }
            }));
            this.subscriptions.push(this.deleteService.loading$.subscribe(value => {
                this.deleteLoading = value;
            }));
        } else {
            this.subscriptions.push(this.deleteService.deleteErrors$.subscribe(value => {
                if (value) {
                    this.toastControl.presentError(value);
                }
            }));
            this.subscriptions.push(this.deleteService.deleteLoading$.subscribe(value => {
                this.deleteLoading = value;
            }));
        }
    }
  }

  onDeletionConfirmed() {
    const payload = this.deleteBuildPayload ? this.deleteBuildPayload(this.entity) : this.entity;
    console.log(['delete payload', payload]);
    this.deleteService.delete(payload)
        .then((value) => {
          if (value) {
              this.entityDeleted.emit(value);
              this.toastControl.presentConfirmation(this.deleteConfirmationMessage);
          }
        })
        .catch((e) => this.toastControl.presentError(e));
  }

  get displayUpdateButton(): boolean {
      if (this.hideUpdateButton === true) {
          return false;
      }
    const permissions: PermissionsModel = PermissionUtils.getPermission(this.entity);
    const updatable = permissions?.updatable;
    return (!!this.resolveUpdateUrl && this.resolveUpdateUrl(this.entity) || this.updateButtonClicked.observers.length > 0)
        && updatable;
  }



  get displayMetadata(): boolean{
    return this.showMetadata && (this.entity instanceof EntityWithAuditMetadata || this.entity instanceof EntityWithCreatedAtMetadata);
  }

  get metadataDate(): Moment {

    if (this.entity instanceof EntityWithAuditMetadata) {
      return this.entity.updatedAt;
    }

    if (this.entity instanceof EntityWithCreatedAtMetadata) {
      return this.entity.createdAt;
    }
  }

  get metadataUpdaterName(): string {
    if (this.entity instanceof EntityWithAuditMetadata) {
        return this.entity.updatedBy?.name;
    }
    if (this.entity instanceof EntityWithCreatedAtMetadata) {
        return this.entity.createdBy?.name;
    }
  }

  click(event){
      if (event?.target?.localName !== 'ion-button' && event?.target?.localName !== 'a' && event?.target?.role !== 'button') {
          if (this.href) {
              this.redirectToWithinCurrentApp(this.href);
          }
    }
  }

  onUpdate() {
      if (this.updateButtonClicked) {
          this.updateButtonClicked.emit(this.entity);
      }
      if (this.resolveUpdateUrl) {
          super.redirectTo(this.resolveUpdateUrl(this.entity), {}, this.urlAfterEdition);
      }
  }

  clicked() {
      this.viewClicked.emit(this.entity);
      // console.log('clicked', this.href);
      if (this.href) {
          this.redirectToWithinCurrentApp(this.href);
      }
  }
}
